import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { sendPasswordResetEmail } from "@/services/passwordHandler";
import { fetchUserAttributes } from "aws-amplify/auth";
import { Card } from "@/components/ui/card";

const ChangePassword = () => {
  const [email, setEmail] = useState("");
  const [emailLocked, setEmailLocked] = useState(false); // ✅ controls if field is editable
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const getEmail = async () => {
      try {
        const attributes = await fetchUserAttributes();
        if (attributes?.email) {
          setEmail(attributes.email);
          setEmailLocked(true); // ✅ only lock if we actually fetched email
        }
      } catch (err) {
        console.warn("User not logged in or failed to fetch email.");
      }
    };

    getEmail();
  }, []);

  const handlePasswordReset = async () => {
    try {
      setLoading(true);
      setError("");

      await sendPasswordResetEmail(email);

      toast.success("Verification code sent to your email.");
      history.push(`/verify-reset-code?email=${encodeURIComponent(email)}`);
    } catch (err) {
      console.error("Error initiating password reset:", err.message);
      setError(err.message || "Failed to initiate password reset.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-full">
      <div className="max-w-2xl w-full mx-8 mt-8">
        <Card className="p-8">
          <h2 className="text-2xl font-semibold mb-6 text-center">
            Reset Your Password
          </h2>

          <div className="space-y-4">
            <div className="space-y-2">
              <Label className="text-md">Email Address</Label>
              <Input
                className="h-8 w-full"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                disabled={emailLocked} // 🔒 lock if user is logged in
              />
            </div>

            <Button
              className="w-full mt-2"
              onClick={handlePasswordReset}
              disabled={loading || !email}
            >
              {loading ? "Sending..." : "Send Verification Code"}
            </Button>

            {error && <p className="text-red-500 mt-2">{error}</p>}
          </div>
        </Card>
      </div>
    </div>
  );
};

export default ChangePassword;
